import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyCuWSxEJyKnwlBoZ3Ji7CL6VF39jQe0yBU",
  authDomain: "facebook-messen.firebaseapp.com",
  databaseURL: "https://facebook-messen.firebaseio.com",
  projectId: "facebook-messen",
  storageBucket: "facebook-messen.appspot.com",
  messagingSenderId: "1022665851013",
  appId: "1:1022665851013:web:dcddbba830e78b70e9a9ec",
  measurementId: "G-23ZT2LJPRL",
});

const db = firebaseApp.firestore();

export default db;
